<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { InputPrimary } from '@shared/ui/fields'

import { useLessonConnection } from '../../model/lessons/lesson-connection.hook'

defineOptions({
  name: 'LessonConnection',
})

const {
  refFields,
  refHasStatus,
} = useLessonConnection()
</script>

<template>
  <div class="lesson-connection">
    <AppText name="body1-medium">
      Connection status
    </AppText>
    <div
      v-if="refHasStatus"
      class="lesson-connection__grid"
    >
      <InputPrimary
        v-for="field in refFields"
        :id="field.id"
        :key="field.id"
        :label="field.label"
        :value="field.value"
        type="text"
        readonly
      />
    </div>
    <AppText
      v-else
      name="body2"
      color="slate-500"
    >
      No connection status
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./LessonConnection.scss" />
